import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-bim-detail',
  templateUrl: './bim-detail.component.html',
  styleUrls: ['./bim-detail.component.less']
})
export class BimDetailComponent implements OnInit {

  constructor() { }

  @Input() bimData: any;

  ngOnInit(): void {
    const myBimDiv = document.getElementById('bim-table') as HTMLDivElement;
    myBimDiv.innerHTML = this.showProperties(this.bimData.Name, this.bimData);
  }

  showProperties(name: any, data: any): string {
    let html = null;
    for (const prop in data) {
        if (!data.hasOwnProperty(prop)) {
            continue;
        }
        if (html == null) {
            // tslint:disable-next-line: max-line-length
            html = '<div style="height:580px;overflow-y:auto;">';
            html += '<table border="1">';
            html += '<tr><th>属性名</th><th>属性值</th></tr>';
        }
        if (prop === 'groupedParam') {
            // 处理分组属性
            const groupedData = data[prop];
            for (const propGrouped in groupedData) {
                if (!groupedData.hasOwnProperty(propGrouped)) {
                    continue;
                }
                const groupLabel = propGrouped.split('-');
                html += '<tr><td class="tdGroup" colspan="2">' + groupLabel[groupLabel.length - 1].trim() + '</td></tr>';
                const group = groupedData[propGrouped];
                for (const propSub in group) {
                    if (!group.hasOwnProperty(propSub)) {
                        continue;
                    }
                    html += '<tr><td class="tdName">' + propSub + '</td><td class="tdValue">' + group[propSub] + '</td></tr>';
                }
            }
        } else {
            // 处理未分组属性
            html += '<tr><td class="tdName">' + prop + '</td><td class="tdValue">' + data[prop] + '</td></tr>';
        }
    }
    if (html == null) {
        html = '<div class="balloonInfo">' + name + '未查询到相关属性<div>';
    } else {
        html += '</table>';
        html += '</div>';
    }
    return html;
  }

}
